import { Template } from './interface'

export const filterDeviceTemplates = <T extends { name?: string }>(
    templates: T[],
): T[] =>
    templates.filter((t) => !(t.name ?? '').toLowerCase().includes('device'))

export const getAutoSelectedTemplateId = (templates: Template[]): string => {
    if (
        Array.isArray(templates) &&
        templates.length === 1 &&
        (!templates[0].subEntityTypes ||
            templates[0].subEntityTypes.length === 0)
    ) {
        return templates[0].id
    }
    return ''
}

export const isProgramSelectionMandatory = (
    availableOrgList: any[] | undefined,
    selectedProgramId: string,
): boolean => {
    return (
        Array.isArray(availableOrgList) &&
        availableOrgList.length > 1 &&
        !selectedProgramId
    )
}
